import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "reason",
    "codeSection",
    "code",
    "quantitySection",
    "quantity",
    "explainSection",
    "citationSection",
    "message"
  ]

  connect() {
    this.onReasonChanged();
    this.onCodeChanged();

    var elements = this.element.querySelectorAll('[type=checkbox]');
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      element.addEventListener('change', this.onOptionsChanged.bind(this));
    }
  }

  onReasonChanged() {
    if (this.reasonTarget.value == "Clinical") {
      this.citationSectionTarget.classList.remove("hidden");
    } else {
      this.citationSectionTarget.classList.add("hidden");
    }

    if (['Coding: upcoded', 'Coding: coded incorrectly'].indexOf(this.reasonTarget.value) >= 0) {
      this.codeSectionTarget.classList.remove('hidden');
    } else {
      this.codeSectionTarget.classList.add('hidden');
      this.codeTarget.value = '';
      this.onCodeChanged();
    }

    if (['Coding: quantity'].indexOf(this.reasonTarget.value) >= 0) {
      this.quantitySectionTarget.classList.remove('hidden');
    } else {
      this.quantitySectionTarget.classList.add('hidden');
      this.quantityTarget.value = '';
    }
  }

  onCodeChanged() {
    // This part is intentionally commented out.
    // For now we'll rely on coders to type a custom/freeform statement to indicate why we think there's upcoding.
    return;

    // Start by hiding all the code options
    var codes = ['99281','99282','99283','99284'];
    for (var i = 0; i < codes.length; i++) {
      var element = document.getElementById('options-' + codes[i]);
      element.classList.add('hidden');
    }

    // If the code entered matches one of these, reveal it.
    if (codes.indexOf(this.codeTarget.value) >= 0) {
      var element = document.getElementById('options-' + this.codeTarget.value);
      element.classList.remove('hidden');
    }
  }

  onOptionsChanged() {
    // Form a message using the checked options

    var checkedValues = [];
    var checkedElements = this.element.querySelectorAll('[type=checkbox]:checked');
    for (var i = 0; i < checkedElements.length; i++) {
      checkedValues.push(checkedElements[i].value);
    }

    var message = "";
    if (checkedValues.length == 1) {
      this.messageTarget.value = "This code is substantiated by the following intervention found in my medical record: " + checkedValues[0];
    } else if (checkedValues.length > 1) {
      this.messageTarget.value = "This code is substantiated by the following interventions found in my medical record: " + new Intl.ListFormat('en', { style: 'long', type: 'conjunction' }).format(checkedValues);
    }
  }
}